const copilotLocalize = {
  'cannot update when copilot is running':
    'Erro ao executar ação. Produções sendo reprocessadas no momento, por favor atualize a página',
};

export default copilotLocalize;
